export const ANALYTIC_ROUTES = [
  {
    path: '/sales-analytics',
    name: 'SalesAnalytics',
    component: () => import('./views/SalesAnalytics.vue'),
  },
  {
    path: '/production-analytics',
    name: 'ProductionAnalytics',
    component: () => import('./views/ProductionAnalytics.vue'),
  },
]
